import { TenantRegistrationRoutes } from '@/repository/auth';
const { Store, FreeTrial } = TenantRegistrationRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ commit }, data) {
			try {
				return await Store(data)
			}
			catch (error) {
				console.error('Tenant could not be registered', error);
				throw error;
			}
		},
		async freeTrial({ commit }, data) {
			try {
				return await FreeTrial(data)
			}
			catch (error) {
				console.error('Tenant could not register for free trial', error);
				throw error;
			}
		},
	}
}
